<template>
  <v-container fluid full-height>
    <v-row justify="center">
      <v-col sm="10" md="10">
        <terminal-form-list-card />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import TerminalFormListCard from "@/terminal-forms/components/terminal-forms/TerminalFormListCard.vue";
</script>
